import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../app/shared/enums/common';
import {AddNewSelectControl} from '../../../app/shared/classes/controls';

export const PanelAccountsUseControl = (): AddNewSelectControl => {
    return new AddNewSelectControl({
        name: '',
        value: null,
        placeholder: 'Cash Account',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.AddNewSelect,
        options: [],
        addNewText: 'Add New Account'
    });
};
